__turbopack_context__.v({
  "axisLine": "AnalysisOverview-module__Pr5IBa__axisLine",
  "blurred": "AnalysisOverview-module__Pr5IBa__blurred",
  "card": "AnalysisOverview-module__Pr5IBa__card",
  "cardHeader": "AnalysisOverview-module__Pr5IBa__cardHeader",
  "cardHint": "AnalysisOverview-module__Pr5IBa__cardHint",
  "cardTitle": "AnalysisOverview-module__Pr5IBa__cardTitle",
  "chart": "AnalysisOverview-module__Pr5IBa__chart",
  "chartInner": "AnalysisOverview-module__Pr5IBa__chartInner",
  "container": "AnalysisOverview-module__Pr5IBa__container",
  "cursor": "AnalysisOverview-module__Pr5IBa__cursor",
  "empty": "AnalysisOverview-module__Pr5IBa__empty",
  "fillGood": "AnalysisOverview-module__Pr5IBa__fillGood",
  "fillLow": "AnalysisOverview-module__Pr5IBa__fillLow",
  "fillMedium": "AnalysisOverview-module__Pr5IBa__fillMedium",
  "fillTypeClosing": "AnalysisOverview-module__Pr5IBa__fillTypeClosing",
  "fillTypeDemo": "AnalysisOverview-module__Pr5IBa__fillTypeDemo",
  "fillTypeDiscovery": "AnalysisOverview-module__Pr5IBa__fillTypeDiscovery",
  "fillTypeInterview": "AnalysisOverview-module__Pr5IBa__fillTypeInterview",
  "fillTypeOther": "AnalysisOverview-module__Pr5IBa__fillTypeOther",
  "grid": "AnalysisOverview-module__Pr5IBa__grid",
  "item": "AnalysisOverview-module__Pr5IBa__item",
  "itemLabel": "AnalysisOverview-module__Pr5IBa__itemLabel",
  "itemMain": "AnalysisOverview-module__Pr5IBa__itemMain",
  "itemValue": "AnalysisOverview-module__Pr5IBa__itemValue",
  "items": "AnalysisOverview-module__Pr5IBa__items",
  "kpi": "AnalysisOverview-module__Pr5IBa__kpi",
  "kpiLabel": "AnalysisOverview-module__Pr5IBa__kpiLabel",
  "kpiRatio": "AnalysisOverview-module__Pr5IBa__kpiRatio",
  "kpiTotal": "AnalysisOverview-module__Pr5IBa__kpiTotal",
  "kpiValue": "AnalysisOverview-module__Pr5IBa__kpiValue",
  "kpis": "AnalysisOverview-module__Pr5IBa__kpis",
  "labelTooltip": "AnalysisOverview-module__Pr5IBa__labelTooltip",
  "legend": "AnalysisOverview-module__Pr5IBa__legend",
  "legendDot": "AnalysisOverview-module__Pr5IBa__legendDot",
  "legendItem": "AnalysisOverview-module__Pr5IBa__legendItem",
  "loaderContainer": "AnalysisOverview-module__Pr5IBa__loaderContainer",
  "nextStep": "AnalysisOverview-module__Pr5IBa__nextStep",
  "pie": "AnalysisOverview-module__Pr5IBa__pie",
  "pieCell": "AnalysisOverview-module__Pr5IBa__pieCell",
  "pieLegend": "AnalysisOverview-module__Pr5IBa__pieLegend",
  "pieLegendItem": "AnalysisOverview-module__Pr5IBa__pieLegendItem",
  "pieTotal": "AnalysisOverview-module__Pr5IBa__pieTotal",
  "pieWrapper": "AnalysisOverview-module__Pr5IBa__pieWrapper",
  "scoreDot": "AnalysisOverview-module__Pr5IBa__scoreDot",
  "scoreGradient": "AnalysisOverview-module__Pr5IBa__scoreGradient",
  "scoreLine": "AnalysisOverview-module__Pr5IBa__scoreLine",
  "tick": "AnalysisOverview-module__Pr5IBa__tick",
  "tooltip": "AnalysisOverview-module__Pr5IBa__tooltip",
  "tooltipLabel": "AnalysisOverview-module__Pr5IBa__tooltipLabel",
  "tooltipName": "AnalysisOverview-module__Pr5IBa__tooltipName",
  "tooltipRow": "AnalysisOverview-module__Pr5IBa__tooltipRow",
  "tooltipScore": "AnalysisOverview-module__Pr5IBa__tooltipScore",
  "tooltipStack": "AnalysisOverview-module__Pr5IBa__tooltipStack",
  "tooltipValue": "AnalysisOverview-module__Pr5IBa__tooltipValue",
  "topicLabel": "AnalysisOverview-module__Pr5IBa__topicLabel",
  "topicTooltip": "AnalysisOverview-module__Pr5IBa__topicTooltip",
  "trend": "AnalysisOverview-module__Pr5IBa__trend",
  "trendDown": "AnalysisOverview-module__Pr5IBa__trendDown",
  "trendUp": "AnalysisOverview-module__Pr5IBa__trendUp",
});
